import { render, staticRenderFns } from "./FromToCard.vue?vue&type=template&id=6023133e&scoped=true"
import script from "./FromToCard.vue?vue&type=script&lang=js"
export * from "./FromToCard.vue?vue&type=script&lang=js"
import style0 from "./FromToCard.vue?vue&type=style&index=0&id=6023133e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023133e",
  null
  
)

export default component.exports